/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */
import { Grid, Typography } from '@mui/material';
import { FormikProvider, useFormik } from 'formik';
import React from 'react';
import FormField from 'src/js/components/common/fields/FormField';

export const RECAPTCHA_VERSIONS = [
  { value: 'v2', label: 'reCAPTCHA v2 (checkbox)' },
  { value: 'v3', label: 'reCAPTCHA v3 (invisible, score based)' }
];

interface Props {
  formik: ReturnType<typeof useFormik>;
}

const Recaptcha = ({ formik }: Props) => (
  <FormikProvider
    value={formik}
  >
    <Grid container columnSpacing={3} rowSpacing={2}>
      <Grid item xs={12}>
        <Typography variant="caption" color="textSecondary">
          Protect website forms from spam with Google reCAPTCHA.
          Create site and secret keys in the Google reCAPTCHA admin console for the selected version.
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <FormField
          type="select"
          name="recaptchaVersion"
          label="reCAPTCHA version"
          items={RECAPTCHA_VERSIONS}
          selectValueMark="value"
          selectLabelMark="label"
        />
      </Grid>
      {formik.values.recaptchaVersion === 'v3' && (
        <Grid item xs={6}>
          <FormField
            type="text"
            name="recaptchaMinScore"
            label="reCAPTCHA min score to pass check"
            placeholder="0.5"
          />
        </Grid>
      )}
      <Grid item xs={12}>
        <FormField
          type="text"
          name="googleRecaptchaKey"
          label="Site key"
        />
      </Grid>
      <Grid item xs={12}>
        <FormField
          type="text"
          name="recaptchaSecretKey"
          label="Secret key"
        />
      </Grid>
    </Grid>
  </FormikProvider>
);

export default Recaptcha;